import axios from 'axios';
import router from '@/router';
import { currentLocale, resetLocale, t } from '@/i18n';

// Create an Axios instance
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 10000
});

// Intercept requests to add the Authorization header
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwt'); // method used to store the token
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    // the API answers (messages, emails) in the language the user sees
    config.headers['Accept-Language'] = currentLocale();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// A 401 from the API means the token is missing, invalid or expired:
// drop the local session and send the user back to the login page.
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const hadSession = !!localStorage.getItem('jwt');
    if (error.response && error.response.status === 401 && hadSession) {
      ['userId', 'expiration', 'jwt'].forEach((key) => localStorage.removeItem(key));
      resetLocale();
      router.push({ name: 'login' });
    }
    return Promise.reject(error);
  }
);

// Plain-text message for a failed request (API message first, then a generic fallback)
export function getErrorMessage(error) {
  return (error.response && error.response.data && error.response.data.message)
    || t('common.genericError');
}

export default apiClient;
